import type { AppState } from '../state/appState.js';
import { getViewportCanvasFrameSize } from './viewportFrame.js';

const AUTO_VIEWPORT_MIN_SIZE = 128;

export interface ViewportResolution {
  w: number;
  h: number;
}

export function getEffectiveViewportResolution(appState: AppState): ViewportResolution {
  if (appState.viewportSizeMode === 'fixed') {
    return { w: appState.resolution, h: appState.resolution };
  }

  const frameSize = getViewportCanvasFrameSize();
  if (!frameSize) return { w: appState.resolution, h: appState.resolution };

  return {
    w: Math.max(AUTO_VIEWPORT_MIN_SIZE, Math.floor(frameSize.w)),
    h: Math.max(AUTO_VIEWPORT_MIN_SIZE, Math.floor(frameSize.h)),
  };
}
